<div class="modal" id="agendaModal">
    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
        <div class="modal-dialog modal-xl" style="top: 5%;">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header" style="padding: 20px;">
                    <h5 class="modal-title headingValue">Create Agenda</h5>
                    <button type="button" class="close" #agendaDismiss data-dismiss="modal"
                        (click)="closeAgendaModal()">&times;</button>

                </div>

                <!-- Modal body -->
                <div class="modal-body container">
                    <form [formGroup]="agendaForm">
                        <div class="form-group">
                            <div class="col-sm-12">
                                <label class="control-label col-md-10 ">Sub Section <span
                                        class="aseticcolor">*</span></label>
                                <select class="form-control" tabindex="1" formControlName="subSection">
                                    <option value="" disabled selected style="color:orange">Select Sub Section</option>
                                    <option *ngFor="let section of subSectionList" [value]="section.agendaSubSectionId">
                                        {{section.agendaSubSectionName}}
                                    </option>
                                </select>
                                <div *ngIf="agendaFormSubmitted && agendaForm.controls['subSection'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            Sub Section Required
                        </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="col-sm-12">
                                <label class="control-label col-md-10 ">Agenda Subject<span class="text-danger">
                                        *</span></label>
                                <textarea class="form-control" rows="5" placeholder="Agenda Subject"
                                    formControlName="agendaItemSubj" maxlength="2000"></textarea>
                            </div>
                            <div *ngIf="agendaFormSubmitted && agendaForm.controls['agendaItemSubj'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            Subject Required
                        </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <label class="control-label col-md-10 ">Agenda Matter<span class="text-danger">
                                        *</span></label>
                                <ckeditor [config]='config'
                                    src="https://cdn.ckeditor.com/4.16.2/standard-all/ckeditor.js"
                                    formControlName="agendaMatter"> </ckeditor>
                            </div>
                            <div *ngIf="agendaFormSubmitted && agendaForm.controls['agendaMatter'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            Matter Required
                        </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3" style="margin-left: 3%;">
                                <label class="control-label">Agenda Document<span class="text-danger">
                                    </span></label>
                            </div>
                            <div class="col-md-4" style="margin-top:8px; margin-bottom:8px;">
                                <input type="file" #myInput accept=".xlsx,.xlsm,.xlsb,.xltx,.pdf,.doc,.docx,.docm,.ppt,.pptx,.png,.jpg,.jpeg,.txt,.csv,.xls,.xla,.dot,.dotx" style="height: fit-content;" class="form-control" id="file" 
                                formControlName="createAgendaFile" [ngClass]="{ 'is-invalid':  agendaFormSubmitted && f.createAgendaFile.errors }" multiple (change)="getFileDetails($event)">
                                <div class="smallCard" *ngFor="let file of files; let i=index">
                                    <div class="row">
                                        <div class="col-md-10">
                                            {{i+1}}.{{file.name}}
                                        </div>
                                        <div class="col-md-2 text-right">
                                            <span class="fas fa-times" style="color:red;font-size: 20px;cursor: pointer;" (click)="removed(i)"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                    </form>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button class="globalBtn submitBtn" data-dismiss="modal" [disabled]="!agendaForm.valid" (click)="agendaCreate()">Submit</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal"
                        (click)="closeAgendaModal()">Close</button>

                </div>
            </div>
        </div>
    </div>
</div>

<button type="button" #openModal class="btn btn-primary" data-toggle="modal" data-backdrop="static"
    data-target="#agendaModal" style="display: none;">
    Open modal
</button>